export const AUTH_TYPES ={
    LOGIN:'LOGIN',
    REGISTER :'REGISTER',
    
}

 